import React from "react";
import { useStartDateTime } from "../../../../services/DateService";

/**
 * Render the Date cell
 *
 * @param game The game to get the date from
 */
export const DateCell = ({ game, className }: { game: any; className?: string }) => {
  const startDateTime = useStartDateTime(game.startDate);
  return (
    <div className={className ? className : "games-table-column__date-cell"}>
      <div className="justify-content-start games-table-column__text-container">
        <p className="games-table-column__date-text">{startDateTime}</p>
      </div>
      <div className="games-table-column__text-container" />
    </div>
  );
};
